<template>
  <div class="mobile-nav-container">
    <div class="header-close">
      <i class="iconfont icon-close" @click="closeMenu"></i>
    </div>
    <div class="header-top">
      <Logo></Logo>
    </div>
    <div class="header-bottom">
      <HeaderLink></HeaderLink>
    </div>
  </div>
</template>

<script>
import Logo from "../logo";
import HeaderLink from "../../headerLink.vue";
import Bus from "@/libs/bus";

export default {
  name: "MobileNav",
  data() {
    return {
      isScrolled: false
    }
  },
  props: {},
  components: { Logo, HeaderLink },
  computed: {},
  mounted() {
    this.handleScroll();
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      requestAnimationFrame(() => {
        this.isScrolled = window.scrollY > 0;
      });
    },
    closeMenu() {
      Bus.$emit("is-open-menu", {
        open: false
      });
    }
  },
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>